export default "__VITE_ASSET__CrmhJhSB__$_?url__"